import { FC, useCallback, useEffect, useState } from "react";
import { dispatch } from "../dispatch/dispatch";
import { actions } from "../dispatch/actions";

// Cancelled after preparation (user 2026-10-13): an order the team packed / printed / prepared — or that was waiting
// to be handed over to Jumia or Marjane — was cancelled. Big red warning on every scanner tab until the worker
// confirms the items are back on their shelf (synced on every device).
interface Item { sku: string; name: string; imageUrl: string; qty: number; location: string; groupName: string }
interface Alert { key: string; platform: "jumia" | "marjan"; store: string; number: string; cancelledAt: string | null; stage: string; city?: string | null; address?: string | null; items: Item[] }
const STAGE_AR: Record<string, string> = {
    "packed": "كان مْباكي (تم ✓)",
    "label printed": "طبعتي ليه الإتيكيت",
    "ready to ship": "كان واجد باش يتسلم لجوميا",
    "prepared": "وجدتيه (prêt)",
    "BL printed — to hand over to Marjane": "طبعتي BL — كان غادي يتسلم لمرجان",
};

export const CancelAlerts: FC = () => {
    const [alerts, setAlerts] = useState<Alert[]>([]);
    const [busy, setBusy] = useState<string | null>(null);
    const load = useCallback(async () => { const r: any = await dispatch(actions.getCancelAlerts); if (Array.isArray(r)) setAlerts(r); }, []);
    useEffect(() => { load(); const t = window.setInterval(load, 60000); return () => window.clearInterval(t); }, [load]);
    const ack = async (key: string) => { setBusy(key); await dispatch(actions.ackCancelAlert, { key }); setBusy(null); setAlerts((a) => a.filter((x) => x.key !== key)); };
    if (!alerts.length) return null;
    return (
        <div className="mx-3 my-3 space-y-3">
            {alerts.map((a) => (
                <div key={a.key} className="rounded-2xl border-4 border-red-600 bg-red-50 p-3 shadow-lg">
                    <p className="text-2xl font-black text-red-700">⛔ هاد الكوموند تلغات! حلّ الكولي ورجّع السلعة لبلاصتها</p>
                    <p className="ltr mt-1 text-start text-base font-bold text-red-800">
                        {a.platform === "jumia" ? "JUMIA" : "MARJANE"} · {a.store} · N° {a.number} — annulée{a.cancelledAt ? ` le ${new Date(a.cancelledAt).toLocaleDateString("fr-MA")}` : ""} · ne pas remettre au livreur
                    </p>
                    <p className="mt-1 text-base font-bold text-red-700">{STAGE_AR[a.stage] || a.stage}</p>
                    {(a.city || a.address) && <p className="mt-1 inline-block rounded-lg bg-white px-2 py-0.5 text-base font-black text-slate-800">📍 المدينة ديال الكليان: <span className="ltr">{a.city || "?"}</span>{a.address ? <span className="ltr block text-sm font-bold text-slate-500">{a.address}</span> : null}</p>}
                    <div className="mt-2 space-y-1.5">
                        {a.items.map((i, k) => (
                            <div key={k} className="ltr flex items-center gap-2 rounded-xl bg-white p-1.5">
                                {i.imageUrl ? <img src={i.imageUrl} alt="" className="h-14 w-14 rounded-lg object-contain" /> : <div className="h-14 w-14 rounded-lg bg-slate-100" />}
                                <span className="rounded-lg bg-red-600 px-2 py-0.5 text-lg font-black text-white">{i.qty}×</span>
                                <span className="min-w-0 flex-1 text-start">
                                    {i.groupName && <span className="block text-base font-black uppercase text-indigo-900">📦 {i.groupName}</span>}
                                    <span className="block text-sm font-bold text-slate-600">{i.name}</span>
                                </span>
                                {i.location ? <span className="rounded-lg bg-slate-900 px-2 py-1 font-mono text-lg font-black text-white">📍 {i.location}</span>
                                    : <span className="rounded-lg bg-amber-100 px-2 py-1 text-sm font-black text-amber-800">📍 ?</span>}
                            </div>
                        ))}
                    </div>
                    <button disabled={busy === a.key} onClick={() => ack(a.key)} className="mt-3 w-full rounded-xl bg-red-600 py-3 text-xl font-black text-white active:bg-red-700">
                        {busy === a.key ? "…" : "✓ رجّعت السلعة لبلاصتها"}
                    </button>
                </div>
            ))}
        </div>
    );
};
